import * as React from 'react';
import Helmet from 'react-helmet';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RequestStatus } from '@store/types';
import { app as routes } from '@configs/routes.json';

import ResetPasswordSubmitted from './ResetPasswordSubmitted';
import './ResetPassword.scss';

export interface ResetPasswordStateProps {
  error?: JSX.Element | string;
  status: RequestStatus;
}

export interface ResetPasswordDispatchProps {
  resetPassword: (email: string) => void;
}

const ResetPassword: React.FC<
  ResetPasswordStateProps & ResetPasswordDispatchProps
> = ({ status, error, resetPassword }) => {
  const { t } = useTranslation();

  const [email, setEmail] = React.useState('');
  const [validationError, setValidationError] = React.useState('');

  const onResetPassword = (e: React.MouseEvent) => {
    e.preventDefault();

    if (!email) {
      setValidationError(t('resetPassword_error_missingEmail'));
      return;
    }
    setValidationError('');
    resetPassword(email);
  };

  const displayedError = validationError || error;

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('resetPassword_title')}</title>
      </Helmet>
      {status === RequestStatus.completed ? (
        <ResetPasswordSubmitted />
      ) : (
        <div className='login reset-password mx-auto'>
          <div>
            <h1>{t('resetPassword_heading')}</h1>
            <div className='px-2'>
              {displayedError ? (
                <div className='error mb-2'>{displayedError}</div>
              ) : null}
              <form>
                <div className='form-group'>
                  <label htmlFor='emailInput'>{t('login_email')}</label>
                  <input
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className='form-control'
                    id='emailInput'
                  />
                </div>
                <div className='text-right'>
                  {status === RequestStatus.inProgress ? (
                    <button className='btn btn-dark btn-sm' disabled>
                      <span
                        className='spinner-border spinner-border-sm mr-2'
                        role='status'
                        aria-hidden='true'
                      ></span>
                      {t('resetPassword_button', { uppercase: true })}
                    </button>
                  ) : (
                    <button
                      className='btn btn-primary btn-sm'
                      onClick={(e) => onResetPassword(e)}
                    >
                      {t('resetPassword_button', { uppercase: true })}
                    </button>
                  )}
                  <NavLink to={routes.login}>
                    <button className='btn btn-light btn-sm ml-2'>
                      {t('common_cancel', { uppercase: true })}
                    </button>
                  </NavLink>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ResetPassword;
